export const HEIGHT_QR_CODE = 250
export const WIDTH_QR_CODE = 250

const getQrCodeRequest = (mid: string, amount: string, intentId: string, type: string = 'BASE64', mobile: number) => {
  return {
    data: {
      merchantId: mid,
      type: amount?.length > 0 ? 'DYNAMIC' : 'STATIC',
      qrInterfaceType: 'UPI',
      amount: amount?.length > 0 ? amount : undefined,
      intentId: intentId,
      medium: 'INTENT',
      qrInterface: {
        height: HEIGHT_QR_CODE,
        width: WIDTH_QR_CODE,
      },
      notification: {
        sms: [`+91${mobile}`],
      },
      paymentAcceptance: ['526'],
    },
    config: {
      outputType: type,
    },
  }
}
export { getQrCodeRequest }
